import { status } from '../../config.ts'
import {
  articleChangeRequestDetail,
  articleChangeRequestPage1,
  articleDeleteRequestDetail,
  articleDeleteRequestPage1,
  articleEditRequestDetail,
  articleEditRequestPage1,
  articleReassignRequestDetail,
  articleReassignRequestPage1,
  clientEditRequestDetail,
  clientEditRequestPage1,
  creditDeletionHasLateQuotes,
  releaseRequestPage1,
  requestComments,
  warrantyRequestDetail
} from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { editArticleRequestCuotesPage1 } from '@/__mocks__/modules/articles/data.ts'

export default [
  {
    method: 'GET',
    path: '/warranty-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, releaseRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/client-editing-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, clientEditRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/credit-editing-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, articleEditRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/credit-change-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, articleChangeRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/credit-reassign-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, articleReassignRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/credit-deletion-requests?limit=20&page=1',
    reply: async () => {
      await wait()
      return [status.ok, articleDeleteRequestPage1]
    }
  },
  {
    method: 'GET',
    path: '/warranty-requests/1',
    reply: async () => {
      await wait()
      return [status.ok, warrantyRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/client-editing-requests/2',
    reply: async () => {
      await wait()
      return [status.ok, clientEditRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/credit-deletion-requests/2',
    reply: async () => {
      await wait()
      return [status.ok, articleDeleteRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/credit-deletion-requests/by-register-number/8131943/has-late-quotes',
    reply: async () => {
      await wait()
      return [status.ok, creditDeletionHasLateQuotes]
    }
  },
  {
    method: 'GET',
    path: '/credit-reassign-requests/2',
    reply: async () => {
      await wait()
      return [status.ok, articleReassignRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/credit-change-requests/2',
    reply: async () => {
      await wait()
      return [status.ok, articleChangeRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/credit-editing-requests/1',
    reply: async () => {
      await wait()
      return [status.ok, articleEditRequestDetail]
    }
  },
  {
    method: 'POST',
    path: '/credit-editing-requests/1/reject',
    reply: async () => {
      await wait()
      return [status.ok, articleEditRequestDetail]
    }
  },
  {
    method: 'POST',
    path: '/credit-editing-requests/1/approve',
    reply: async () => {
      await wait()
      return [status.ok, articleEditRequestDetail]
    }
  },
  {
    method: 'GET',
    path: '/credit-editing-requests/1/quote',
    reply: async () => {
      await wait()
      return [status.ok, editArticleRequestCuotesPage1]
    }
  },
  {
    method: 'POST',
    path: '/credit-editing-requests/1/quote',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/credit-editing-requests/1/quote/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/credit-editing-requests/1/quote/2',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: '/warranty-requests-comments/1',
    reply: async () => {
      await wait()
      return [status.ok, requestComments]
    }
  },
  {
    method: 'POST',
    path: '/warranty-requests-comments/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/request/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/warranty-requests/1/status',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/warranty-requests/1/approve',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/client-editing-requests/2/approve',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/client-editing-requests/2/reject',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credit-deletion-requests/2/approve',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credit-deletion-requests/2/reject',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credit-reassign-requests/2/approve',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credit-reassign-requests/2/reject',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'POST',
    path: '/credit-deletion-requests/2/status',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
